$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });




jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  var ekTarget = document.querySelector('.el-pdp-pdt-heading2');
  if (ekTarget) ekTarget.scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});




$(document).on("click", ".el-element-option", function(e) {
$(this).parents('.el-product').find('.el-element-option').removeClass('el-active');
$(this).addClass('el-active');
var data_tab = $(this).attr('data_tab');
$(this).parents('.el-product').find('.el-quantity-data').hide();
$(this).parents('.el-product').find('.el-quantity-data[data_tab="'+data_tab+'"]').show();
});











$(document).on("click", ".el-cart-button", function (e) {
window.upcartOpenCart?.();
});


function getLimit() {
  return window.innerWidth <= 768 ? 3 : 6;
}

$(document).on("click", "a[href='#show']", function (e) {
  e.preventDefault();

  var limit = getLimit();

  $('.el-pdp-review2-list1-item:nth-child(' + limit + ') ~ .el-pdp-review2-list1-item')
    .slideDown();

  $('.el-pdp-review2-reads:has(a[href="#show"])').hide();
  $('.el-pdp-review2-reads:has(a[href="#hide"])').show();
});

$(document).on("click", "a[href='#hide']", function (e) {
  e.preventDefault();

  var limit = getLimit();

  $('.el-pdp-review2-list1-item:nth-child(' + limit + ') ~ .el-pdp-review2-list1-item')
    .slideUp();

  $('.el-pdp-review2-reads:has(a[href="#hide"])').hide();
  $('.el-pdp-review2-reads:has(a[href="#show"])').show();
});



  $(document).on("click", '.el-atc-js:not(.el-sold-out)', function (e) {
  e.preventDefault();
  var $btn = $(this);
  if ($btn.hasClass('el-loading')) return;
  $btn.addClass('el-loading');
  var items = [];
var variant_id = $btn.attr('variant_id');
  var item = {
    id: parseInt(variant_id),
    quantity: 1
  };
  items.push(item);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('el-loading');
      }, 500);
    }
  });
});











$(function () {

    $('.el-element-variants').each(function () {

        const $wrapper = $(this);

        const variants = JSON.parse(
            $wrapper.find('.el-variants-json').html()
        );

        function getSelectedOptions() {

            let selectedOptions = [];

            const firstOption = $wrapper
                .find('.el-variant-option-item.el-active .el-variant-option-title')
                .attr('value');

            if (firstOption) {
                selectedOptions.push(firstOption);
            }

            $wrapper.find('.el-product-option-select').each(function () {
                selectedOptions.push($(this).val());
            });

            return selectedOptions;
        }

        function updateVariant() {

            const selectedOptions = getSelectedOptions();

            const matchedVariant = variants.find(function (variant) {

                return variant.options.every(function (option, index) {
                    return option == selectedOptions[index];
                });

            });

            if (matchedVariant) {

                $wrapper
                    .find('.el-product-variant-id')
                    .val(matchedVariant.id)
                    .trigger('change');
            }

            updateAvailability();
        }

        function updateAvailability() {

            const currentSelections = getSelectedOptions();

            // First option (swatches)
            $wrapper.find('.el-variant-option-item').each(function () {

                const $item = $(this);

                const value = $item
                    .find('.el-variant-option-title')
                    .attr('value');

                const testSelections = [...currentSelections];
                testSelections[0] = value;

                const available = variants.some(function (variant) {

                    if (!variant.available) {
                        return false;
                    }

                    return variant.options.every(function (option, index) {

                        if (!testSelections[index]) {
                            return true;
                        }

                        return option == testSelections[index];
                    });

                });

                $item
                    .toggleClass('el-disabled', !available);
            });

            // Remaining select options
            $wrapper.find('.el-product-option-select').each(function () {

                const $select = $(this);
                const optionIndex = parseInt($select.data('option-position')) - 1;

                $select.find('option').each(function () {

                    const $option = $(this);
                    const optionValue = $option.val();

                    const testSelections = [...currentSelections];
                    testSelections[optionIndex] = optionValue;

                    const available = variants.some(function (variant) {

                        if (!variant.available) {
                            return false;
                        }

                        return variant.options.every(function (option, index) {

                            if (!testSelections[index]) {
                                return true;
                            }

                            return option == testSelections[index];
                        });

                    });

                    $option.prop('disabled', !available);

                });

            });

        }

        $wrapper.on('click', '.el-variant-option-item', function () {

            if ($(this).hasClass('el-disabled')) {
                return;
            }

            $wrapper
                .find('.el-variant-option-item')
                .removeClass('el-active');

            $(this).addClass('el-active');

            updateVariant();
        });

        $wrapper.on('change', '.el-product-option-select', function () {
            updateVariant();
        });

        updateAvailability();

    });

});







(function () {

    const ORIGINAL_PANTS_ID = 9414160384225;    // /products/roadarmor-pants (this page)
    const HALLOWEEN_PANTS_ID = 9735959871713;   // unlisted Halloween copy (/products/roadarmor-halloween)
    const BOGO_PANTS_ID = 10319039398113;       // 1 + 1 deal copy (/products/roadarmor-bogo), same gifts as the original
    const B_PANTS_ID = 10335371002081;          // free shipping split test copy (/products/roadarmor-pants-b), same gifts as the original
    const WOMEN_PANTS_ID = 9534889558241;       // Women's Edition (/products/roadarmor-riding-pants-woman-editon), same gifts as the original (2026-10-15)
    const BF_PANTS_IDS = { 10342330761441: true, 10342330859745: true };   // 2026-11-04: Veterans Day camo 10343823442145 taken out at Nathan's request, it earns no belt in the cart (the page still shows the free belt)   // Black Friday copies + Veterans Day copy 10343823442145 (belt only, 2026-10-07) (VIP early access + public, 2026-10-06): belt only, no gaiter

    // Rule: every gift follows the product that earned it.
    //   belt              -> any RoadArmor pants (1 pants = 1 belt, 2+ pants = 2 belts)
    //   neck gaiter       -> the ORIGINAL pants only, 1 pants = 1 gaiter, 2+ pants = 2 gaiters (2026-09-30) (the BOGO copy counts as original)
    //   summer mask       -> retired 2026-09-29, removed from any cart that still holds it
    //   3 Halloween gifts -> the Halloween pants; the Halloween page adds them, this
    //                        page only removes them once no Halloween pants is left
    // expectedQty receives {required, original, halloween} (pants quantities in the
    // cart) and returns the quantity of that gift that belongs in the cart, or null
    // to leave that gift line alone.
    const FREE_GIFTS = [
        {   // hidden $0 RoadArmor Belt
            productId: 9531169407201,           // used to match cart lines
            variantId: 48591395160289,          // cart/add.js requires a VARIANT id
            expectedQty: function (q) { return Math.min(q.required, 2); }
        },
        {   // hidden $0 EKON Fleece Lined Neck Gaiter, 2 Pack (free gift since 2026-09-29)
            productId: 10329156092129,
            variantId: 50613149401313,
            expectedQty: function (q) { return Math.min(q.original, 2); }
        },
        {   // retired gift: EKON Summer Balaclava UPF 50+, removed if a cart still holds it
            productId: 9670214451425,
            variantId: 48900898128097,
            expectedQty: function (q) { return 0; }
        },
        {   // hidden $0 EKON Ghost Print Balaclava (Halloween page gift, remove only here)
            productId: 9732226089185,
            variantId: 49154509832417,
            expectedQty: function (q) { return q.halloween > 0 ? null : 0; }
        },
        {   // hidden $0 EKON Grim Reaper Ride Bell (Halloween page gift; no size, so this page adds it too)
            productId: 9737699819745,
            variantId: 49196203639009,
            expectedQty: function (q) { return q.halloween > 0 ? 1 : 0; }
        },
        {   // retired gift: EKON Bloody Handprint Decals, removed if a cart still holds it
            productId: 9735795409121,
            variantId: 49183531598049,
            expectedQty: function (q) { return 0; }
        },
        {   // hidden $0 EKON Skeleton Glow Gloves, any size (Halloween page gift, remove only here)
            productId: 9735795507425,
            variantId: 49183533367521,
            expectedQty: function (q) { return q.halloween > 0 ? null : 0; }
        }
    ];

    const CART_HEADERS = { 'Content-Type': 'application/json' };
    // upcart=1 + opens_cart=never: UpCart treats the request as its own and does not open the drawer
    const ADD_URL = '/cart/add.js?upcart=1&opens_cart=never';

    let syncRunning = false;
    let syncQueued = false;
    const changeTimes = [];             // times of the passes that changed the cart (last minute)
    const MAX_CHANGES_PER_MINUTE = 8;   // a healthy session never needs this many, a loop does
    let breakerTimer = null;
    const failedAt = {};                // productId -> time of the last failed cart request
    const RETRY_AFTER_MS = 30000;       // a gift that failed is retried after 30 s, not hammered

    function fetchCart() {
        return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
            if (!r.ok) throw new Error('cart.js ' + r.status);
            return r.json();
        });
    }

    function changeLine(key, quantity) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: CART_HEADERS,
            body: JSON.stringify({ id: key, quantity: quantity })
        });
    }

    function addVariant(variantId, quantity) {
        return fetch(ADD_URL, {
            method: 'POST',
            headers: CART_HEADERS,
            body: JSON.stringify({ id: variantId, quantity: quantity })
        });
    }

    // UpCart passes {cart} with its events: an empty cart needs no sync at all
    function eventCartIsEmpty(evt) {
        return !!(evt && evt.cart && evt.cart.items && evt.cart.items.length === 0);
    }

    async function syncFreeGifts(evt) {

        if (eventCartIsEmpty(evt)) return;

        // skip overlapping runs; the queued flag guarantees one final pass
        if (syncRunning) {
            syncQueued = true;
            return;
        }

        // circuit breaker, per burst: if the cart keeps getting changed by this
        // script (an app fighting the gifts, or a race) stop for 15 s, then run
        // one recovery pass. Counted over the last minute, so an alternating
        // fight (change, no change, change, ...) trips it too.
        while (changeTimes.length && Date.now() - changeTimes[0] > 60000) changeTimes.shift();
        if (changeTimes.length >= MAX_CHANGES_PER_MINUTE) {
            if (!breakerTimer) {
                breakerTimer = setTimeout(function () {
                    breakerTimer = null;
                    changeTimes.length = 0;
                    syncFreeGifts();
                }, 15000);
            }
            return;
        }

        syncRunning = true;
        let cartChanged = false;

        try {

            const cart = await fetchCart();

            // 1. scan the cart
            const q = { required: 0, original: 0, halloween: 0 };
            const giftLines = {};

            cart.items.forEach(function (item) {

                if (item.product_id === ORIGINAL_PANTS_ID || item.product_id === BOGO_PANTS_ID || item.product_id === B_PANTS_ID || item.product_id === WOMEN_PANTS_ID) {
                    q.original += item.quantity;
                    q.required += item.quantity;
                } else if (BF_PANTS_IDS[item.product_id]) {
                    q.required += item.quantity;      // Black Friday pants: belt only
                } else if (item.product_id === HALLOWEEN_PANTS_ID) {
                    q.halloween += item.quantity;
                    q.required += item.quantity;
                }

                FREE_GIFTS.forEach(function (gift) {
                    if (item.product_id === gift.productId && !giftLines[gift.productId]) {
                        giftLines[gift.productId] = item;
                    }
                });
            });

            const now = Date.now();

            // 2. bring every gift to its expected quantity
            //    (change.js with quantity 0 removes the line)
            for (const gift of FREE_GIFTS) {

                if (failedAt[gift.productId] && now - failedAt[gift.productId] < RETRY_AFTER_MS) continue;

                const expectedQty = gift.expectedQty(q);
                if (expectedQty === null) continue;      // not this page's gift to manage right now

                const line = giftLines[gift.productId];

                if (line) {

                    if (line.quantity !== expectedQty) {
                        const res = await changeLine(line.key, expectedQty);
                        if (!res.ok) { failedAt[gift.productId] = now; continue; }
                        cartChanged = true;
                    }

                } else if (expectedQty > 0) {

                    const res = await addVariant(gift.variantId, expectedQty);
                    if (!res.ok) { failedAt[gift.productId] = now; continue; }
                    cartChanged = true;
                }
            }

            if (cartChanged && typeof window.upcartRefreshCart === 'function') {
                window.upcartRefreshCart();
            }

            // 3. update the cart counter UI (from a fresh cart if we changed it)
            const freshCart = cartChanged ? await fetchCart() : cart;
            updateCartCounter(freshCart);

        } catch (err) {

            // network hiccup: the next cart event runs the sync again

        } finally {

            if (cartChanged) changeTimes.push(Date.now());
            syncRunning = false;

            if (syncQueued) {
                syncQueued = false;
                syncFreeGifts();
            }
        }
    }

    // Register with UpCart. upcartSubscribeCartUpdated survives UpCart's own
    // initialization, while a plain upcartOnCartUpdated assignment gets
    // overwritten with a no-op when UpCart's bundle loads after this file.
    // The cart-loaded event gives one pass per page view so a cart that was
    // changed elsewhere (other page, other tab) is settled here too.
    // One settle pass per page view. UpCart re-fires cart-loaded on every cart
    // change (cart-updated already covers those), so only the first one counts,
    // and if UpCart loaded the cart before this async file ran, a timer runs it.
    let loadPassSeen = false;

    function onCartLoaded(evt) {
        if (loadPassSeen) return;
        loadPassSeen = true;
        syncFreeGifts(evt);
    }

    function subscribe() {
        window.upcartSubscribeCartUpdated(syncFreeGifts);
        if (typeof window.upcartSubscribeCartLoaded === 'function') {
            window.upcartSubscribeCartLoaded(onCartLoaded);
        }
        setTimeout(function () {
            if (loadPassSeen) return;
            loadPassSeen = true;
            syncFreeGifts();
        }, 1500);
    }

    function registerGiftSync() {

        if (typeof window.upcartSubscribeCartUpdated === 'function') {
            subscribe();
            return;
        }

        // UpCart not loaded yet: cover the gap, then move to the
        // subscribe API as soon as it appears
        window.upcartOnCartUpdated = syncFreeGifts;

        var tries = 0;
        var timer = setInterval(function () {

            tries++;

            if (typeof window.upcartSubscribeCartUpdated === 'function') {
                clearInterval(timer);
                subscribe();
                return;
            }

            if (tries > 150) {
                clearInterval(timer);
            }
        }, 200);
    }

    registerGiftSync();

})();

function updateCartCounter(cart) {

    const totalQty = cart.items.reduce((sum, item) => {
        return sum + item.quantity;
    }, 0);

    const counter = document.querySelector('.el-cart-count');

    if (!counter) return;

    if (totalQty <= 0) {
        counter.style.display = 'none';
        return;
    }

    counter.style.display = 'inline-flex';
    counter.textContent = totalQty;
}
